import * as Sentry from '@sentry/browser';

if (process.env.REACT_APP_SENTRY_URI) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_URI,
    environment: process.env.REACT_APP_ENVIRONMENT,
    release: process.env.REACT_APP_VERSION_TAG,
  });
}
